import { IAuthorizationFail, IAuthorizationPass } from './authorize'
import { getApiUrlForEnv } from '../../utils/ApiUrl'

const buildUrl = (url: string): string => {
  const EnvUrl = getApiUrlForEnv()
  return process.env.NODE_ENV === 'production' ? `${EnvUrl}${'/'}${url}` : url
}

const sendEmailPassword = async (values: {
  token: string
  password: string
}): Promise<IAuthorizationPass> => {
  const response = await fetch(buildUrl('/api/v2/user/password/'), {
    body: JSON.stringify({
      token: values.token,
      password: values.password,
    }),
    method: 'POST',
  })

  const responseBody:
    | IAuthorizationPass
    | IAuthorizationFail = await response.json()
  if ('error' in responseBody) {
    throw new Error(responseBody.error_description)
  }

  return responseBody as IAuthorizationPass
}
export default sendEmailPassword
